<template>
  <div
    :id="props.id || baseDataTestid"
    :data-testid="`${props.dataTestid}-${baseDataTestid}-container`"
    :class="twMerge('rounded-lg py-4 px-2 bg-secondary grid place-items-center', props.appendClass)"
  >
    <TsTypography
      :data-testid="props.dataTestid + '-' + baseDataTestid"
      weight="semibold"
      size="md"
      append-class="text-white"
      >-{{ props.discount }}</TsTypography
    >
  </div>
</template>

<script lang="ts" setup>
import { twMerge } from "tailwind-merge";

// PROPS
type Props = {
  id?: string;
  discount: string;
  appendClass?: string;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {
  appendClass: "",
});

const baseDataTestid = "product-discount-badge";
</script>